import PropTypes from 'prop-types';

const YoutubeEmbed = ({ embedId }) => {
  if (!embedId) {
    return (
      <div className='video-responsive my-6 bg-gray-100 p-6 rounded-sm text-center'>
        <p>No YouTube video ID provided</p>
      </div>
    );
  }

  const embedUrl = `https://www.youtube-nocookie.com/embed/${embedId}?rel=0&modestbranding=1&controls=1&showinfo=0&iv_load_policy=3&disablekb=0&fs=1&loop=0&cc_load_policy=0`;

  return (
    <div className='video-responsive my-6'>
      <div className='relative pb-[56.25%] h-0 overflow-hidden rounded-lg'>
        <iframe
          className='absolute top-0 left-0 w-full h-full'
          src={embedUrl}
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        />
      </div>
    </div>
  );
};

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string,
};

export default YoutubeEmbed;
